<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <mtc-form-item label="tableHeader.tableName">
              <a-input :placeholder="$t('label.pleaseEnter', { field: $t('tableHeader.tableName')})" v-model="queryParam.tableName" />
            </mtc-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <mtc-button type="primary" @click="searchQuery" icon="search" text="button.search" />
              <mtc-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px" text="button.reset" />
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button @click="doCgformButton" type="primary" icon="highlight">自定义按钮</a-button>
       <a-button @click="doEnhanceJs" type="primary" icon="strikethrough">JS增强</a-button>
       <a-button @click="doEnhanceSql" type="primary" icon="filter">SQL增强</a-button>
       <a-button @click="doEnhanceJava" type="primary" icon="tool">Java增强</a-button>-->
      <!--<a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete"/>
            删除
          </a-menu-item>
        </a-menu>
        <a-button> 批量操作
          <a-icon type="down"/>
        </a-button>
      </a-dropdown>-->
    </div>
    <!-- table区域-begin -->
    <div>
      <a-alert style="margin: 10px 0">
        <template slot="message">
          <a-icon class="anticon ant-alert-icon" theme="filled" type="info-circle" />
          <span style="margin-left: 20px">
          <!-- 已选择 -->
          <mtcLangPopover text="tip.selected" />：
            <!-- 条数 -->
          <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>
            <!-- 单位 -->
          <mtcLangPopover text="tip.term" />
          <mtcLangPopover text="button.clear">
            <a style="margin-left: 24px" @click="onClearSelected">{{ $t('button.clear') }}</a>
          </mtcLangPopover>
        </span>
        </template>
      </a-alert>
      <a-table ref="table"
               size="middle"
               bordered
               rowKey="id"
               :columns="tableColumns"
               :dataSource="dataSource"
               :pagination="ipagination"
               :loading="loading"
               :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
               @change="handleTableChange">
        <!-- 表头自定义渲染 -->
        <template v-for="(item, index) in tableColumns" :slot="item.slotName">
          <mtcHeader :key="index" :text="item.slotName" />
        </template>
        <template slot="action" slot-scope="text, record">
          <mtcLangPopover text="button.edit">
            <a @click="handleEdit(record)">{{ $t('button.edit') }}</a>
          </mtcLangPopover>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              <mtcLangPopover text="button.more" />
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <mtcLangPopover text="button.functionTest">
                  <a @click="goPageOnline(record)">{{ $t('button.functionTest') }}</a>
                </mtcLangPopover>
              </a-menu-item>
              <a-menu-item>
                <mtcLangPopover text="button.configureAddress">
                  <a @click="handleOnlineUrlShow(record)">{{ $t('button.configureAddress') }}</a>
                </mtcLangPopover>
              </a-menu-item>
              <a-menu-item>
                <mtcLangPopover text="button.accessControl">
                  <a @click="goAuthConfig(record.id)">{{ $t('button.accessControl') }}</a>
                </mtcLangPopover>
              </a-menu-item>
              <a-menu-item>
                <mtcLangPopover text="button.roleAuthorization">
                  <a @click="doAuthConfig(record.id)">{{ $t('button.roleAuthorization') }}</a>
                </mtcLangPopover>
              </a-menu-item>
              <a-menu-item>
                <mtcLangPopover text="button.remove">
                  <a @click="handleRemoveRecord(record.id)">{{ $t('button.remove') }}</a>
                </mtcLangPopover>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
        <template slot="dbsync" slot-scope="text">
          <span v-if="text==='Y'" style="color:limegreen">{{ $t('tip.synced') }}</span>
          <span v-if="text==='N'" style="color:red">{{ $t('tip.notSynced') }}</span>
        </template>
      </a-table>
    </div>
    <!-- 提示online报表链接 -->
    <a-modal :title="onlineUrlTitle"
             :visible="onlineUrlVisible"
             @cancel="handleOnlineUrlClose">
      <template slot="footer">
        <mtc-button @click="handleOnlineUrlClose" style="margin-right: 8px" text="button.close" />
        <mtc-button type="primary" class="copy-this-text" :data-clipboard-text="onlineUrl" @click="onCopyUrl" text="button.copy" />
      </template>
      <p>{{ onlineUrl }}</p>
    </a-modal>
    <enhance-js ref="ehjs" />
    <enhance-sql ref="ehsql" />
    <enhance-java ref="ehjava" />
    <trans-db2-online ref="transd2o" @ok="transOk" />
    <onl-cgform-button-list ref="btnList" />
    <auth-manager ref="authManager" />
    <auth-setter ref="authSetter" />
    <!-- 表单区域 -->
    <onl-cgform-head-modal ref="modalForm" @ok="modalFormOk" :action-button="false" />
  </a-card>
</template>

<script>
import OnlCgformHeadModal from './modules/OnlCgformHeadModal'
import { deleteAction, postAction, getAction } from '@/api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import Clipboard from 'clipboard'
import { filterObj } from '@/utils/util'

import EnhanceJs from './modules/EnhanceJs'
import EnhanceSql from './modules/EnhanceSql'
import EnhanceJava from './modules/EnhanceJava'
import TransDb2Online from './modules/TransDb2Online'
import OnlCgformButtonList from './button/OnlCgformButtonList'
import AuthManager from './auth/AuthManager'
import AuthSetter from './auth/AuthSetter'
import { changeLangColumn } from '@/utils/langUtils'

export default {
  name: 'OnlCgformHeadList',
  mixins: [JeecgListMixin],
  components: {
    OnlCgformHeadModal,
    EnhanceJs,
    EnhanceSql,
    EnhanceJava,
    TransDb2Online,
    OnlCgformButtonList,
    AuthManager,
    AuthSetter
  },
  data() {
    return {
      description: 'Online表单视图',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '视图表名',
          language_key: 'tableHeader.viewTableName',
          align: 'center',
          dataIndex: 'tableName'
        },
        {
          title: '视图表描述',
          language_key: 'tableHeader.viewTableDescription',
          align: 'center',
          dataIndex: 'tableTxt'
        },
        {
          title: '原表版本',
          language_key: 'tableHeader.originalVersion',
          align: 'center',
          dataIndex: 'copyVersion'
        },
        {
          title: '视图版本',
          language_key: 'tableHeader.viewVersion',
          align: 'center',
          dataIndex: 'tableVersion'
        },
        {
          title: '操作',
          language_key: 'tableHeader.operate',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/online/cgform/head/list',
        delete: '/online/cgform/head/delete',
        deleteBatch: '/online/cgform/head/deleteBatch',
        removeRecord: '/online/cgform/head/removeRecord'
      },
      tableTypeDictOptions: [],
      sexDictOptions: [],
      syncModalVisible: false,
      syncFormId: '',
      synMethod: 'normal',
      syncLoading: false,
      onlineUrlTitle: '',
      onlineUrlVisible: false,
      onlineUrl: '',
      selectedRowKeys: [],
      selectedRows: [],
      physicId: ''
    }
  },
  computed: {
    tableColumns() {
      return changeLangColumn(this.columns)
    }
  },
  watch: {
    '$route'() {
      this.loadData()
    }
  },
  methods: {
    getQueryParams() {
      //获取查询条件
      var param = Object.assign({}, this.queryParam, this.isorter, this.filters)
      param.field = this.getQueryField()
      param.pageNo = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      param.copyType = 1
      param.physicId = this.physicId
      if (this.superQueryParams) {
        param[ 'superQueryParams' ] = encodeURI(this.superQueryParams)
        param[ 'superQueryMatchType' ] = this.superQueryMatchType
      }
      return filterObj(param)
    },
    loadData(arg) {
      if (!this.$route.params.code) {
        return false
      }
      this.physicId = this.$route.params.code
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!')
        return
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      var params = this.getQueryParams()//查询条件
      this.loading = true
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        }
        if (res.code === 510) {
          this.$message.warning(res.message)
        }
        this.loading = false
      })
    },
    goPageOnline(rd) {
      if (rd.isTree == 'Y') {
        this.$router.push({ path: '/online/cgformTreeList/' + rd.id })
      } else {
        this.$router.push({ path: '/online/cgformList/' + rd.id })
      }
    },
    handleOnlineUrlClose() {
      this.onlineUrlTitle = ''
      this.onlineUrlVisible = false
    },
    handleOnlineUrlShow(record) {
      if (record.isTree == 'Y') {
        this.onlineUrl = `/online/cgformTreeList/${record.id}`
      } else {
        this.onlineUrl = `/online/cgformList/${record.id}`
      }
      this.onlineUrlVisible = true
      this.onlineUrlTitle = '菜单链接[' + record.tableTxt + ']'
    },
    handleRemoveRecord(id) {
      let that = this
      this.$confirm({
        title: '确认要移除此记录?',
        onOk() {
          deleteAction(that.url.removeRecord, { id: id }).then((res) => {
            if (res.success) {
              that.$message.success(res.message)
              that.loadData()
            } else {
              that.$message.warning(res.message)
            }
          })
        },
        onCancel() {
        }
      })
    },
    // 判断是否列表中选中了一条数据
    isSelectOne() {
      if (!this.selectedRowKeys || this.selectedRowKeys.length !== 1) {
        this.$message.warning(this.$t('tip.pleaseSelectARecord'))
        return false
      }
      return true
    },
    doEnhanceJs() {
      if (!this.isSelectOne()) return
      this.$refs.ehjs.show(this.selectedRowKeys[ 0 ])
    },
    doEnhanceSql() {
      if (!this.isSelectOne()) return
      this.$refs.ehsql.show(this.selectedRowKeys[ 0 ])
    },
    doEnhanceJava() {
      if (!this.isSelectOne()) return
      this.$refs.ehjava.show(this.selectedRowKeys[ 0 ])
    },
    doCgformButton() {
      if (!this.isSelectOne()) return
      this.$refs.btnList.show(this.selectedRowKeys[ 0 ])
      //this.$router.push({ path: '/online/cgformButton/' + this.selectedRowKeys[0] })
    },
    importOnlineForm() {
      this.$refs.transd2o.show()
    },
    transOk() {
      this.loadData()
    },
    onSelectChange(keys, rows) {
      this.selectedRowKeys = keys
      this.selectedRows = rows
    },
    onCopyUrl() {
      var clipboard = new Clipboard('.copy-this-text')
      clipboard.on('success', () => {
        clipboard.destroy()
        this.$message.success(this.$t('tip.copySuccessfully'))
        this.handleOnlineUrlClose()
      })
      clipboard.on('error', () => {
        this.$message.error('该浏览器不支持自动复制')
        clipboard.destroy()
      })
    },
    showMyCopyInfo(id) {
      console.log('查看复制表单的信息', id)
    },
    copyConfig(id) {
      postAction(`${this.url.copyOnline}?code=${id}`).then(res => {
        if (res.success) {
          this.$message.success(this.$t('tip.copySuccessfully'))
          this.loadData()
        } else {
          this.$message.error('复制失败>>' + res.message)
        }
      })
    },
    goAuthConfig(id) {
      this.$refs.authManager.show(id)
    },
    doAuthConfig(id) {
      this.$refs.authSetter.show(id)
    }
  }
}
</script>

<style scoped lang="less">
@import '~@assets/less/common.less';

.ant-card-body .table-operator {
  margin-bottom: 8px;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 15px;
  padding-bottom: 15px;
}

.anty-row-operator button {
  margin: 0 5px
}

.ant-btn-danger {
  background-color: #ffffff
}

.ant-modal-cust-warp {
  height: 100%
}

.ant-modal-cust-warp .ant-modal-body {
  height: calc(100% - 110px) !important;
  overflow-y: auto
}

.ant-modal-cust-warp .ant-modal-content {
  height: 90% !important;
  overflow-y: hidden
}

.valid-error-cust {
  .ant-select-selection {
    border: 2px solid #f5222d;
  }
}
</style>